import React, { Component } from "react";
import {
  InputGroup,
  Row,
  Col,
  Table
} from "reactstrap";
import Select from "react-select";
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import Moment from 'react-moment';
import Messages from '../../notifications/Messages';
import Errors from '../../notifications/Errors';
import * as chuongTrinhConstant from './constants'
import * as chuongTrinhAction from './actions'
import { storedb } from '../client/storedb'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { customSelectStylesMulti } from '../../lib/common'

class ChuongTrinh extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      stores_id: dbContext.getStoreId(),
      listKieuChuongTrinh: chuongTrinhConstant.CHUONGTRINH_LIST_KIEU,
      item: {},
      nhomKh: [],
      treeProduct: [],
      checked: [],
      expanded: [],
      list: [],
      treeProvince: [],
      provinceChecked: [],
      provinceExpanded: [],
      selectedNhomKhOption: [],
      IsDeleted: '',
      keyword: '',
      per_page: 5000,
      page: 1,
      chuongtrinhId : 0,
      tenChuongTrinh: ''
    };
  }
  componentDidMount() {
    this.fetchListNhomKh();
    this.fetchListProduct();
    this.fetchListCampaign();
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  productOnChecked = (checked, node) => {
    if (!node.checked && node.children && node.children.length > 0) {
      // neu uncheck thi kiem tra lại trong list có removed chưa
      const val = node.value + ''
      const index = checked.indexOf(val)
      if (index > -1) {
        checked.splice(index, 1)
      }
    }
    this.setState({ checked })
  }
  handleChangeNhomKh = selectedNhomKhOption => {
    this.setState({ selectedNhomKhOption });
  }
  fetchListNhomKh = () => {
    const onSuccess = ({data}) => {
      if (data) {
        this.setState({ nhomKh: data })
      } else {
        this.setState({ nhomKh: [] })
      }
    }
    return this.props.chuongTrinhListNhomKhRequest({}, onSuccess);
  }  
  fetchListCampaign = () => {
    const {selectedNhomKhOption} = this.state
    const { chuongTrinhListRequest } = this.props

    var requestData = {
      nhomKhs: selectedNhomKhOption.map(it => { return it.value }),
      keyword: this.state.keyword,
      status: this.state.IsDeleted,
      page: this.state.page,
      per_page: this.state.per_page
    };
    return chuongTrinhListRequest(requestData);
  }
  fetchListProduct = () => {
    const { chuongTrinhProductListRequest } = this.props
    var requestData = {
      ChuongTrinhId: this.state.chuongtrinhId,
      keyword: this.state.keyword,
      stores_id: this.state.stores_id,
      NganhHangId: 0,
      page: 1,
      per_page: 1000,
    }
    return chuongTrinhProductListRequest(requestData);
  }
  genLinkCampaign = (item) => {
    return '/#/chuong-trinh-edit?cid=' + item.ChuongTrinhId;
  }
  EditChuongTrinhItem = (item) => {
    this.props.history.push('/chuong-trinh-edit?cid=' + (item.ChuongTrinhId || ""));
  }
  EditChuongTrinhProduct = (item) => {
    this.props.history.push('/chuong-trinh-product?cid=' + (item.ChuongTrinhId || "") + "&name=" + (item.TenChuongTrinh || ""));
  }
  filterListProduct = (event) => {
    // let { treeProduct } = this.state;
    // var updatedList = this.props.nguoiDungKho.resultNgDung;
    // updatedList = updatedList.filter(function (item) {
    //   return (item.TenDayDu.toLowerCase().search(event.target.value.toLowerCase()) !== -1) || (item.username.toLowerCase().search(event.target.value.toLowerCase()) !== -1);
    // });
    // this.setState({ treeProduct: updatedList })
  }
  updateChuongTrinhProduct = () => {
    let { chuongtrinhId,checked } = this.state;
    if (chuongtrinhId && chuongtrinhId > 0) {
      var requestData = {
        ChuongTrinhId: chuongtrinhId,
        ProductIds: checked,
      }
      this.props.chuongTrinhUpdateProductRequest(requestData);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.chuongTrinh.type == chuongTrinhConstant.CHUONGTRINH_LIST_SUCCESS) {
      let { list, item } = nextProps.chuongTrinh;
      this.setState({
        page: item.page,
        per_page: item.per_page,
        list: this.buildTree(list)
      });
    }
    else if (nextProps.chuongTrinh.type == chuongTrinhConstant.CHUONGTRINH_PRODUCT_LIST_SUCCESS) {
      let { resultProductCt,nganhHang,resultProduct } = nextProps.chuongTrinh;
      var checked = [];
      for (var i in resultProductCt) {
        checked.push(resultProductCt[i].ProductId)
      }
      if( this.state.treeProduct.length <=0)
      {
        this.setState({
          treeProduct: this.buildTreeProduct(resultProduct,nganhHang),
        });
      }
      this.setState({
        checked
      });
    }
    else if (nextProps.chuongTrinh.type == chuongTrinhConstant.CHUONGTRINH_UPDATE_PRODUCT_SUCCESS) {
      let { successful,messages } = nextProps.chuongTrinh;
      this.setState({
        successful,messages
      });
    }
  }
  getnameChuongTrinh = (parentId) => {
    name = ""
    $.each(this.state.listKieuChuongTrinh, function (key, item) {
      if (item.id == parentId) {
        name = item.name;
      }
    });
    return name
  }
  buildTree = (items) => {
    if (items.length == 0) {
      return []
    }
    let list = []
    // build parent
    for (var i = 0; i < items.length; i++) {
      let index = list.findIndex(x => x.key === items[i].Loai)
      if (index === -1) {
        list.push({
          key: items[i].Loai,
          TenChuongTrinh: this.getnameChuongTrinh(items[i].Loai), 
          Status: 1, 
          NgayApDung: '', 
          ChuongTrinhId: 0,
          IsOpenning: i === 0,// mặc định mở item đầu tiên
          IsFocused: false,
          items: []
        })
      }
    }

    for (var i = 0; i < list.length; i++) {
      for (var j = 0; j < items.length; j++) {
        // select index pảent
        if (items[j].Loai === list[i].key) {
          list[i].items.push({
            key: `ct-${items[j].ChuongTrinhId}`,
            ChuongTrinhId: items[j].ChuongTrinhId,
            TenChuongTrinh: items[j].TenChuongTrinh,
            NgayApDung: items[j].NgayApDung,
            NgayKetThuc: items[j].NgayKetThuc,
            IsActive: items[j].IsActive,
            ParentId: list[i].key,
            IsOpenning: list[i].IsOpenning,
            IsFocused: false,
          })
          items.splice(j, 1)
          j--;
        }
      }
    }
    return list;
  }
  
  buildTreeProduct = (listProduc, nganhHangs) => {
    var out = [];
    if (nganhHangs.length > 0) {
      for (var i in nganhHangs) {
        var tmp = new Object();
        tmp.value = nganhHangs[i].NganhHangId +"nganh";
        tmp.label = nganhHangs[i].Ten;
        tmp.type = 1 ;
        var children = listProduc.filter(f => f.NganhHangId === nganhHangs[i].NganhHangId);
        var childrenProd = []
        if (children.length > 0) {
          for (var j in children) {
            var tmpch = new Object();
            tmpch.value = children[j].ProductId;
            tmpch.label = children[j].Sku + '\u00A0-\u00A0' + children[j].Ten;
            tmpch.Sku = children[j].Sku
            tmpch.Ten = children[j].Ten
            tmpch.type = 2 ;
            tmpch.className = "treecheckboxFontsize"
            childrenProd.push(tmpch)
          }
          tmp.children = childrenProd;
        }else 
        {
          tmp.disabled =true
        }
        out.push(tmp)
      }
    }
    return out
  }
  clickChuongTrinh = (e, key) => {
    e.preventDefault()
    let { list } = this.state;
    list = list.map(item => {
      if (item.key != key) {
        item.IsOpenning = false
      } else {
        item.IsOpenning = !item.IsOpenning
      }
      item.items = item.items.map(cItem => {
        cItem.IsOpenning = item.IsOpenning
        return cItem
      })
      return item
    })

    this.setState({ list })
  };

  clickChuongTrinhItem = (e, item) => {
    e.preventDefault()
    let { list } = this.state
    list = list.map(parent => {
      if (parent.key != item.ParentId) {
        return parent
      }
      parent.items = parent.items.map(cItem => {
        if (cItem.key === item.key) {
          cItem.IsFocused = true
        } else {
          cItem.IsFocused = false
        }
        return cItem
      })
      return parent
    })
    this.setState({ list, chuongtrinhId: item.ChuongTrinhId, tenChuongTrinh: item.TenChuongTrinh }, () => {
      this.fetchListProduct();
     });
  }

  render() {
    let { 
      list,
      nhomKh,
      selectedNhomKhOption,
      treeProduct,
    } = this.state;
    const {
      chuongTrinh: {
        errors,
        messages,
        listRequesting
      },
    } = this.props

    const getClassForChild = (item) => {
      let className = ""
      if (!item) {
        return className
      }
      if (!item.IsOpenning) {
        className += " d-none"
      }
      if (item.IsFocused) {
        className += " table-success"
      }
      return className
    }
    const getOptionsLoaiKh = () => {
      if (nhomKh == null) return []
      return nhomKh.map(item => {
        return { value: item.Id, label: item.Ten }
      })
    }
    const renderChildren = (items) => {
      // default hiện item đầu tiên
      return items.map((res, index) => (
        <tr key={index}  className={getClassForChild(res)}>
          <td className="text-center cursor-pointer" onClick={(e) => this.clickChuongTrinhItem(e, res)}></td>
          <td className="text-left table-border-right pl-4 cursor-pointer" onClick={(e) => this.clickChuongTrinhItem(e, res)} >
            {res.TenChuongTrinh}
          </td>
          <td className="text-center table-border-right cursor-pointer" onClick={(e) => this.clickChuongTrinhItem(e, res)}>{res.NgayApDung && <Moment format="DD/MM/YYYY">{`${res.NgayApDung}`}</Moment>}</td>
          <td className="text-center table-border-right cursor-pointer" onClick={(e) => this.clickChuongTrinhItem(e, res)}>{res.NgayApDung && <Moment format="DD/MM/YYYY">{`${res.NgayKetThuc}`}</Moment>}</td>
          <td className="text-center text-danger table-border-right cursor-pointer" onClick={(e) => this.clickChuongTrinhItem(e, res)} >
            {res.ChuongTrinhId > 0 && res.IsActive == 0 ?
              <span className="text-danger"><i className="fa fa-close"></i></span> : <span className="text-success"><i className="fa fa-check"></i></span>}
          </td>
          <td className="text-center text-danger table-border-right">
            <ButtonExt
              btnClass="text-primary"
              iconClass="fa-edit fa-lg"
              btnType={BtnType.ButtonLink}
              hrefLink={this.genLinkCampaign(res)}
              btnClick={() => this.EditChuongTrinhItem(res)}
              permission={BtnPermissions.ChuongTrinh.ADD_OR_UPDATE} />
          </td>
        </tr>
      ))
    }
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <ButtonExt btnClass="mr-1"
                color="primary"
                iconClass="fa-plus"
                displayText="Thêm mới"
                btnClick={() => this.EditChuongTrinhItem({})}
                permission={BtnPermissions.ChuongTrinh.ADD_OR_UPDATE} />
              <ButtonExt
                btnClass="float-right mr-3"
                color="success"
                iconClass="fa fa-save"
                displayText="Lưu"
                btnClick={() => this.updateChuongTrinhProduct()}
                permission={BtnPermissions.ChuongTrinh.ADD_OR_UPDATE} />
            </div>
            <div className="w-100 row">
              <div className="col-sm-7 p-1">
                <InputGroup className="border">
                  <Select
                    styles={customSelectStylesMulti}
                    value={selectedNhomKhOption}
                    onChange={this.handleChangeNhomKh}
                    options={(getOptionsLoaiKh())}
                    placeholder="--Lọc theo nhóm khách hàng--"
                    name="NhomKhachHang" 
                    className="form-control p-0"
                    isMulti
                    closeMenuOnSelect={false}
                  />
                  <div className="input-group-append">
                    <button className="btn btn-outline-primary h-100" onClick={this.fetchListCampaign} type="button"><i className="fa fa-search"></i></button>
                  </div>
                </InputGroup>
                <Table hover responsive className="table-sm table-outline mb-0 d-sm-table">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" width="40" className="text-right"></th>
                      <th scope="col" className="text-left table-border-right">Tên chương trình</th>
                      <th scope="col"  width="110" className="text-center table-border-right">Ngày áp dụng</th>
                      <th scope="col"  width="110" className="text-center table-border-right">Ngày kết thúc</th>
                      <th scope="col" width="50" className="text-center table-border-right">TT</th>
                      <th scope="col"  width="20"className="text-center table-border-right">Sửa</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list && !!list.length && (
                      list.map((row, idx) => [
                        (
                          <tr key={idx + 1}  className={row.IsOpenning ? "table-active" : ""} onClick={(e) => this.clickChuongTrinh(e, row.key)}>
                            <td className="text-right table-border-right">
                              <span >
                                <i className={!row.IsOpenning ?"fa fa-folder text-primary fa-lg" : "fa fa-folder-open text-success fa-lg"}></i>
                              </span>
                            </td>
                            <td colSpan="6">
                              {row.TenChuongTrinh} (<span className="text-green">{row.items ? row.items.length : 0}</span>)
                            </td>
                          </tr>
                        ),
                        renderChildren(row.items)
                      ])
                    )}
                  </tbody>
                </Table>
              </div>
              <div className="col-sm-5 p-1">
                <div className="col-sm-12 p-0 border border-primary">
                  {this.state.tenChuongTrinh != '' && (
                  <InputGroup className="border">
                    <label className="w100 pt-2 pl-2 text-red" >{this.state.tenChuongTrinh}</label>
                    {/* <Input placeholder="Nhập Mã, Tên mặt hàng" onChange={this.filterListProduct}  /> */}
                  </InputGroup>
                  )}
                  <div className="clearfix">
                    <Row>
                      <Col md="12">
                        {!listRequesting && !!errors.length && (
                          <Errors message="Failure to signup due to:" errors={errors} />
                        )}
                        {!listRequesting && !!messages.length && (
                          <Messages messages={messages} />
                        )}
                      </Col>
                    </Row>
                    </div>
                  <CheckboxTree
                    nodes={treeProduct}
                    checked={this.state.checked}
                    expanded={this.state.expanded}
                    onCheck={(checked, node) => this.productOnChecked(checked, node)}
                    onExpand={expanded => this.setState({ expanded })}
                  />
                </div>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  chuongTrinh: state.chuongTrinh,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  chuongTrinhListRequest: chuongTrinhAction.chuongTrinhListRequest,
  chuongTrinhUpdateRequest: chuongTrinhAction.chuongTrinhUpdateRequest,
  chuongTrinhListNhomKhRequest: chuongTrinhAction.chuongTrinhListNhomKhRequest,
  chuongTrinhProductListRequest: chuongTrinhAction.chuongTrinhProductListRequest,
  chuongTrinhUpdateProductRequest:  chuongTrinhAction.chuongTrinhUpdateProductRequest,
})(ChuongTrinh)
const formed = reduxForm({
  form: 'chuongTrinh',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/ChuongTrinh/ChuongTrinh.js